exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".address-update-subs-modal > p[data-v-7b95f279] {\n  padding-bottom: 1em;\n}\n.address-update-subs-modal .prod[data-v-7b95f279] {\n  padding-bottom: 1em;\n}\n.address-update-subs-modal .prod-info[data-v-7b95f279] {\n  padding-left: 0.5em;\n}\n.address-update-subs-modal .prod-info p[data-v-7b95f279] {\n  padding-bottom: 0.5em;\n}\n", ""]);

// exports
